import React from "react";
import {
  Button,
  Card,
  CardContent,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import styles from "../users.module.scss";
import { Textarea } from "../../../components/ui/textArea";

const CancelStep2 = (props) => {
  const {
    setDisplayStep,
    selectedOption,
    setSelectedOption,
    feedBack,
    setFeedBack,
    handleCancelSubscription,
  } = props;

  return (
    <div style={{ maxWidth: "800px", margin: "0px auto" }}>
      <div>
        <div className="mb-15">
          <Button onClick={() => setDisplayStep(0)} className="pl-0">
            <span className="d-flex flex-center dark:text-white text-[#6B7280]">
              {" "}
              <KeyboardBackspaceIcon className="mr-8" fontSize="small" />
              Back to Billing
            </span>
          </Button>
        </div>

        <div>
          <h3 className="dark:text-white text-[#020817]" style={{ fontSize: "24px", fontWeight: "700" }}>
            Cancel Subscription
          </h3>
          <p
            style={{ fontSize: "14px", lineHeight: "20px" }}
            className="mb-0 mt-10 dark:text-white text-[#4B5563] dark:text-white"
          >
            {" "}
            Help us improve our service{" "}
          </p>
        </div>
      </div>

      <Card
        className="mt-30 bg-[#ffffff] dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] border border-[hsl(214.3,31.8%,91.4%)] dark:border-transparent rounded-[6px]"
      >
        <div className="p-24">
          <h3 className="dark:text-white text-[#020817]" style={{ fontSize: "24px", fontWeight: "600" }}>
            {" "}
            Why are you cancelling?{" "}
          </h3>
        </div>
        <CardContent style={{ padding: "0px 24px 24px 24px" }}>
          <RadioGroup
            value={selectedOption}
            onChange={(e) => setSelectedOption(e.target.value)}
            className={styles.radioGroup}
          >
            <FormControlLabel
              value="tooExpensive"
              control={<Radio color="primary" className={styles.radioButton} />}
              label="Too expensive"
              className={`${styles.radioOption} dark:text-white`}
            />
            <FormControlLabel
              value="missingFeatures"
              control={<Radio color="primary" className={styles.radioButton} />}
              label="Missing features"
              className={`${styles.radioOption} dark:text-white`}
            />
            <FormControlLabel
              value="notUsing"
              control={<Radio color="primary" className={styles.radioButton} />}
              label="Not using enough"
              className={`${styles.radioOption} dark:text-white`}
            />
            <FormControlLabel
              value="other"
              control={<Radio color="primary" className={styles.radioButton} />}
              label="Other reason"
              className={`${styles.radioOption} dark:text-white`}
            />
          </RadioGroup>

          <div className="mt-12 w-full">
            <h4 className="mb-4 dark:text-white text-[#020817]" style={{ fontSize: "14px" }}>
              Additional feedback (optional)
            </h4>
            <Textarea
              id="feedback"
              fullWidth={true}
              rows={4}
              value={feedBack}
              onChange={(e) => setFeedBack(e.target.value)}
              placeholder="Tell us more about why you're cancelling..."
            />
          </div>
        </CardContent>
      </Card>

        <div className="d-flex flex-center flex-justify-end mt-20">
          <Button
            style={{ backgroundColor: "#ffffff", color: "black" }}
            variant="outlined"
            onClick={() => setDisplayStep(0)}
          >
            Go Back
          </Button>
          <Button
            className="ml-10"
            style={{ backgroundColor: "green", color: "white" }}
            variant="contained"
            onClick={handleCancelSubscription}
          >
            Confirm Cancel
          </Button>
        </div>
    </div>
  );
};

export default CancelStep2;
